let cachedStats = null;

export function getCachedDashboardStats() {
  return cachedStats;
}

export function setCachedDashboardStats(stats) {
  cachedStats = stats;
}

export function clearCachedDashboardStats() {
  cachedStats = null;
}
